import React, { useEffect } from "react";

const CREST = "https://customer-assets.emergentagent.com/job_career-hub-538/artifacts/li6pjilk_LC-Crest-%28Transparent%29.png";

// Fixed 1920x1080 advertisement poster for school displays.
// Visit /poster and screenshot the viewport at 1920x1080 for a print-ready PNG.
export default function Poster() {
  // Accept ?url= override so you can point the QR at any production/custom domain
  // without a code change. Defaults to the current origin when no override is set.
  const params = new URLSearchParams(window.location.search);
  const targetUrl = params.get("url") || `${window.location.origin}/`;
  const qrSrc = `https://api.qrserver.com/v1/create-qr-code/?size=560x560&margin=8&format=png&qzone=1&data=${encodeURIComponent(targetUrl)}`;

  // Nuke any global page margin/scroll so screenshot is pixel-perfect
  useEffect(() => {
    const prev = { margin: document.body.style.margin, bg: document.body.style.background, overflow: document.body.style.overflow };
    document.body.style.margin = "0";
    document.body.style.overflow = "hidden";
    document.body.style.background = "#0A0A0A";
    return () => {
      document.body.style.margin = prev.margin;
      document.body.style.overflow = prev.overflow;
      document.body.style.background = prev.bg;
    };
  }, []);

  return (
    <div
      data-testid="poster-root"
      style={{
        width: 1920,
        height: 1080,
        position: "relative",
        overflow: "hidden",
        fontFamily: "'Outfit', system-ui, sans-serif",
        color: "#0A0A0A",
        background:
          "radial-gradient(circle at 15% 10%, #FDE68A 0%, transparent 40%)," +
          "radial-gradient(circle at 90% 90%, #FCA5A5 0%, transparent 40%)," +
          "#FFFBEB",
      }}
    >
      {/* Big red banner top-left */}
      <div
        style={{
          position: "absolute",
          top: 60,
          left: 60,
          background: "#C8102E",
          color: "white",
          padding: "12px 28px",
          border: "4px solid #000",
          borderRadius: 999,
          boxShadow: "8px 8px 0 0 #000",
          fontWeight: 800,
          fontSize: 22,
          letterSpacing: "0.15em",
          textTransform: "uppercase",
        }}
      >
        ★ New for Students
      </div>

      {/* Crest top-right */}
      <img
        src={CREST}
        alt=""
        style={{ position: "absolute", top: 40, right: 60, height: 180, width: 180, objectFit: "contain" }}
      />

      {/* Massive headline */}
      <div style={{ position: "absolute", top: 190, left: 60, right: 60, maxWidth: 1200 }}>
        <div
          style={{
            fontSize: 210,
            lineHeight: 0.9,
            fontWeight: 900,
            letterSpacing: "-0.045em",
          }}
        >
          YOUR<br />NEXT<br />
          <span
            style={{
              background: "#FACC15",
              padding: "0 16px",
              border: "6px solid #000",
              display: "inline-block",
              transform: "rotate(-2deg)",
              boxShadow: "10px 10px 0 0 #000",
            }}
          >
            STEP.
          </span>
        </div>
      </div>

      {/* Sub-headline */}
      <div
        style={{
          position: "absolute",
          left: 60,
          top: 820,
          maxWidth: 1150,
          fontSize: 40,
          fontWeight: 700,
          lineHeight: 1.15,
          fontFamily: "'Work Sans', sans-serif",
        }}
      >
        University open days · Apprenticeships · Work experience · Careers events —
        <span style={{ color: "#C8102E" }}> all in one place.</span>
      </div>

      {/* Small tagline near bottom */}
      <div
        style={{
          position: "absolute",
          left: 60,
          bottom: 60,
          fontSize: 26,
          fontWeight: 700,
          fontFamily: "'Work Sans', sans-serif",
          color: "#0A0A0A",
        }}
      >
        Filter by <span style={{ background: "#000", color: "#fff", padding: "2px 10px", borderRadius: 6 }}>YEAR</span>
        &nbsp;and <span style={{ background: "#000", color: "#fff", padding: "2px 10px", borderRadius: 6 }}>OPPORTUNITY TYPE</span>.
        New listings every week.
      </div>

      {/* QR block bottom-right */}
      <div
        style={{
          position: "absolute",
          right: 60,
          bottom: 60,
          background: "#fff",
          border: "6px solid #000",
          borderRadius: 24,
          boxShadow: "12px 12px 0 0 #000",
          padding: 32,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 14,
          width: 620,
        }}
      >
        <div style={{ fontSize: 30, fontWeight: 900, letterSpacing: "0.06em", textTransform: "uppercase" }}>
          Scan to explore
        </div>
        <img src={qrSrc} alt="QR code" width={520} height={520} style={{ display: "block" }} />
        <div
          style={{
            fontFamily: "'Work Sans', sans-serif",
            fontSize: 22,
            fontWeight: 700,
            color: "#374151",
            wordBreak: "break-all",
            textAlign: "center",
            maxWidth: 520,
          }}
        >
          {targetUrl.replace(/^https?:\/\//, "")}
        </div>
      </div>

      {/* Corner marks / accent stripes */}
      <div style={{ position: "absolute", left: 0, top: 0, width: 40, height: 1080, background: "#000" }} />
      <div style={{ position: "absolute", right: 0, top: 0, width: 40, height: 1080, background: "#C8102E" }} />
    </div>
  );
}
